import { FC, ReactNode } from 'react';
import { Row, Col, IRowProps, IColProps } from '@base/lib/ThemeGrid'

type IGridRenderProps<T = any> = IRowProps & {
    list: T[] | undefined;
    render: (item: T, index: number) => ReactNode;
    colProps?: IColProps | ((item: T, index: number) => IColProps);
};

export const GridRender: FC<IGridRenderProps> = props => {
    const { list, render, colProps, ...rest } = props;

    return !list || list.length === 0 ? null : (
        <Row {...rest}>
            {list.map((item, index) => (
                <Col key={index} {...(typeof colProps === 'function' ? colProps(item, index) : colProps)}>
                    {render(item, index)}
                </Col>
            ))}
        </Row>
    )
};
